import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ImageOff } from "lucide-react";

export function AuthImage({ path, alt = "", className = "", testid }) {
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let url;
    let alive = true;
    setFailed(false);
    api.getBlob(path)
      .then((b) => { if (alive) { url = URL.createObjectURL(b); setSrc(url); } })
      .catch(() => alive && setFailed(true));
    return () => { alive = false; if (url) URL.revokeObjectURL(url); };
  }, [path]);
  if (failed) return <div className={`flex items-center justify-center bg-slate-100 text-slate-400 ${className}`} data-testid={testid}><ImageOff size={16} /></div>;
  if (!src) return <div className={`bg-slate-100 animate-pulse ${className}`} data-testid={testid} />;
  return <img src={src} alt={alt} className={`object-cover ${className}`} data-testid={testid} />;
}
